import React, { useContext } from 'react';
import localisation from '../../localisation.json';
import { LanguageContext } from '../App';

function getStatusByLetter(validatedGuesses) {
    const statusObj = {};

    validatedGuesses.forEach((guess) => {
        guess.forEach(({ letter, status }) => {
            if (statusObj[letter] === 'correct') return;
            if (statusObj[letter] === 'misplaced' && status === 'incorrect') {
                return;
            }

            statusObj[letter] = status;
        });
    });

    return statusObj;
}
function Keyboard({ handleLetterPress, validatedGuesses, setIsButtonFocused }) {
    const handleButtonFocus = () => {
        setIsButtonFocused(true);
    };

    const handleButtonBlur = () => {
        setIsButtonFocused(false);
    };
    const { language } = useContext(LanguageContext);
    const keyboardRows = localisation[0].keyboard[language];
    let statusByLetter = getStatusByLetter(validatedGuesses);
    return (
        <div>
            <div className='keyboard'>
                {keyboardRows.map((row, rowIndex) => (
                    <div key={rowIndex} className='keyboard-row'>
                        {row.map((letter, colIndex) => {
                            const isWide =
                                letter === 'ENTER' || letter === 'DELETE';
                            return (
                                <button
                                    className={`keyboard-btn
                                    ${language}
                                    ${statusByLetter[letter || '']}
                                    ${isWide ? 'wide' : ''}
                                    `}
                                    key={colIndex}
                                    onClick={() => handleLetterPress(letter)}
                                    onFocus={
                                        letter !== 'ENTER'
                                            ? handleButtonFocus
                                            : null
                                    }
                                    onBlur={
                                        letter !== 'ENTER'
                                            ? handleButtonBlur
                                            : null
                                    }>
                                    {letter}
                                </button>
                            );
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Keyboard;
